export default "__VITE_ASSET__29c36425__"